<template>
  <div class="c-monitor">
    <!-- filter -->
    <monitor-filter
      placeholder="请输入规则ID或者名称"
      :selection-row="selectionRow"
      @on-change="filterData"
      @on-search="searchFilterData"
      @on-refresh="getData"
      @remove-rows="onRemoveSelectedRows"
    >
      <template #gdt-auth v-if="access.includes('M21236')">
        <el-button @click="onGdtAuth">自动化任务认证</el-button>
      </template>
    </monitor-filter>
    <!-- table -->
    <div class="c-table-list">
      <Viewport v-model="tableHeight">
        <monitor-table
          v-model="selectionRow"
          :height="tableHeight"
          :loading="loading"
          :data="tableList"
          :columns="tableCol"
          @on-refresh="getData"
        />
        <Page
          show-total
          show-sizer
          show-elevator
          :total="total"
          :current.sync="pageIndex"
          :page-size="pageSize"
          :page-size-opts="[10, 20, 30, 40, 100]"
          @on-change="changePageIndex"
          @on-page-size-change="changePageSize"
          class="c-table-page pager"
          size="small"
        />
      </Viewport>
    </div>

    <el-dialog title="自动化任务认证" :visible.sync="showGdtAuthModal" width="400px">
      <el-form label-width="80px">
        <el-form-item>
          <p>
            <span>自动化任务剩余认证天数{{ authExpireDate }}</span>
            <el-button type="text" @click="onGdtAuthorize">去认证</el-button>
          </p>
        </el-form-item>
        <el-form-item label="提醒人">
          <ThrottleSelector v-model="authUserIds" multiple style="width: 100%" :list="SYS_USERS" placeholder="全部" filterable clearable />
          <p style="font-size: 12px">说明：当认证只剩下3天时，会进行钉钉及邮件提醒</p>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onGdtAuthConfigCancel">取 消</el-button>
        <el-button type="primary" @click="onGdtAuthConfigConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import mixin from '../mixins/mixin.js'
import columns from '../data/monitor_column.js'
import { setLocal, getLocal } from '@/common/js/api.js'
import { isArray } from '@/common/js/utils.js'
import { getPlanAutoRule, removePlanAutoRules } from '@/api/manage.model.js'
import { setGdtAuthUserConfig, getGdtAuthUserConfig } from '@/api/tencent.model.js'
import { gotoAuthorize, getAuthInfo, authCallbackHandler } from '@/common/js/gdtAuthUtil.js'
import ThrottleSelector from '@/components/throttle-select/index.vue'
import MonitorFilter from './components/monitor-filter.vue'
import MonitorTable from './components/monitor-table.vue'
import { initPageData, SYS_USERS } from '@/data/global-opts'
const PAGE_REQUIRED_OPTS = initPageData([SYS_USERS])
export default {
  name: 'monitor',
  mixins: [mixin],
  components: { MonitorFilter, MonitorTable, ThrottleSelector },
  data() {
    return {
      tableHeight: 330,
      showGdtAuthModal: false,
      selectionRow: [],
      authUserIds: [],
      authExpireDate: '0天'
    }
  },

  computed: {
    ...PAGE_REQUIRED_OPTS,
    access() {
      return this.$store.state.accessAuth || []
    }
  },
  methods: {
    onGdtAuth() {
      this.showGdtAuthModal = true
      this.getGdtAuthConfig()
    },
    onGdtAuthConfigConfirm() {
      if (!this.authUserIds?.length) return this.$Message.warning('请选择提醒人')
      setGdtAuthUserConfig({
        config: this.authUserIds.join(',')
      }).then((data) => {
        if (data) {
          this.$Message.success('保存成功')
          this.onGdtAuthConfigCancel()
        }
      })
    },
    onGdtAuthConfigCancel() {
      this.showGdtAuthModal = false
    },
    getGdtAuthConfig() {
      getGdtAuthUserConfig().then((data) => {
        if (data) {
          this.authUserIds = data ? data.split(',').map(Number) : []
        }
      })
    },
    async getGdtAuthInfo() {
      const dateText = await getAuthInfo({ managerId: 1 })
      if (dateText) {
        this.authExpireDate = dateText
      }
    },
    onGdtAuthorize() {
      gotoAuthorize(window.location.href)
    },
    /**
     * @description: 批量删除
     */
    onRemoveSelectedRows() {
      const lens = this.selectionRow.length
      if (!lens) return this.$Message.warning('请勾选规则')
      this.$confirm(`确定要删除${lens}条规则吗?`, '提示', {
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        const ruleIds = this.selectionRow.map((row) => row.id)
        removePlanAutoRules({ ruleIds })
          .then((data) => {
            if (data) {
              this.$Message.success('删除成功')
              this.getData()
            }
          })
          .catch((err) => {
            console.log('eeeeee output: ', err)
          })
      })
    },
    getData(filter) {
      let params = {
        page_id: this.pageIndex,
        page_size: this.pageSize
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      this.loading = true
      getPlanAutoRule(params)
        .then((data) => {
          this.loading = false
          if (!data) return
          const { list, page_info } = data
          if (isArray(list) && page_info) {
            const { total_number } = page_info
            this.total = total_number || 0
            this.tableList = list.map((ret) => {
              const { monitorConditionDesc } = ret
              const monitor = monitorConditionDesc.split(';')
              if (isArray(monitor) && monitor.length) {
                const [, ...monitorConditionInfo] = monitor
                ret.monitorConditionDesc = monitorConditionInfo
              }
              const gameList = ret.gameInfo?.split('\n') || []
              ret.gameList = gameList
              ret.rangeTypeText = ret.rangeType === 1 ? '账号级' : '应用级'
              return ret
            })
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    betchChange() {},
    setLocalPage(size) {
      setLocal('MONITOR_PAGESIZE', size)
    }
  },
  created() {
    this.pageSize = parseInt(getLocal('MONITOR_PAGESIZE')) || 20
    this.tableCol = columns
    this.sort = 'create_time'
    this.order = 'desc'

    const { expire_time, user_token, user_status } = this.$route.query || {}
    if (expire_time && user_token) {
      authCallbackHandler({ expire_time, user_token, managerId: 1 }).then(() => {
        this.$router.replace({ name: 'monitorules' })
        this.$Message.success('认证成功')
        this.getGdtAuthInfo()
      })
    } else {
      this.getGdtAuthInfo()
    }

    if (expire_time === '0' && user_token === '') {
      this.$Message.warning('认证失败，请联系管理员')
      this.$router.replace({ name: 'monitorules' })
    }
  },
  activated() {
    if (isArray(this.tableList) && this.tableList.length) this.getData()
  }
}
</script>
<style lang="scss" scoped>
.c-table-page {
  padding: 5px 0;
  text-align: right;
}
</style>
